import { render, staticRenderFns } from "./deleteExamineProject.vue?vue&type=template&id=775d2a4c&scoped=true"
import script from "./deleteExamineProject.vue?vue&type=script&lang=js"
export * from "./deleteExamineProject.vue?vue&type=script&lang=js"
import style0 from "./deleteExamineProject.vue?vue&type=style&index=0&id=775d2a4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775d2a4c",
  null
  
)

export default component.exports